import { render, staticRenderFns } from "./asidelist.vue?vue&type=template&id=36e1f194&scoped=true&"
import script from "./asidelist.vue?vue&type=script&lang=js&"
export * from "./asidelist.vue?vue&type=script&lang=js&"
import style0 from "./asidelist.vue?vue&type=style&index=0&id=36e1f194&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e1f194",
  null
  
)

export default component.exports